import { createFileRoute } from "@tanstack/react-router";

import { CoachAthleteProfilePage } from "src/pages/CoachAthleteProfilePage";

export const Route = createFileRoute(
  "/_auth/_coach/athletes/$athleteId/_tabs/profile",
)({
  component: RouteComponent,
  ssr: true,
});

function RouteComponent() {
  return <CoachAthleteProfilePage />;
}
